export default "__VITE_ASSET__uVbgxJK8__"